const SearchSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 8.75C3.75 6.26472 5.76472 4.25 8.25 4.25C10.7353 4.25 12.75 6.26472 12.75 8.75C12.75 11.2353 10.7353 13.25 8.25 13.25C5.76472 13.25 3.75 11.2353 3.75 8.75ZM8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75C9.63653 14.75 10.9132 14.2797 11.9292 13.4899L14.4697 16.0303C14.7626 16.3232 15.2374 16.3232 15.5303 16.0303C15.8232 15.7374 15.8232 15.2626 15.5303 14.9697L12.9899 12.4292C13.7797 11.4132 14.25 10.1365 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75Z"
      fill="currentColor"
    />
  </svg>
);
export default SearchSvg;
